/**
 * RFC 4122 version 4 UUID for idempotent writes.
 *
 * Extracted from `sale-store.js`, which has generated these since sales gained
 * `client_request_id`. Purchases, receivings, supplier payments, refunds and
 * transfers now carry the same key, and five copies of the same twenty lines is
 * how the copies drift.
 *
 * `crypto.randomUUID()` is not used directly: it is unavailable on insecure
 * origins, and a terminal reached over plain HTTP on a shop LAN is exactly the
 * install that needs this most. The fallback is weaker but the key only has to
 * be unique among one operator's in-flight requests, not unguessable.
 *
 * The server validates and lower-cases it — see App\Support\ClientRequestReplay.
 */
export function newClientRequestId() {
    const bytes = new Uint8Array(16);
    if (globalThis.crypto?.getRandomValues) {
        globalThis.crypto.getRandomValues(bytes);
    } else {
        for (let index = 0; index < bytes.length; index += 1) {
            bytes[index] = Math.floor(Math.random() * 256);
        }
    }

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));

    return [hex.slice(0, 4).join(''), hex.slice(4, 6).join(''), hex.slice(6, 8).join(''), hex.slice(8, 10).join(''), hex.slice(10).join('')].join(
        '-',
    );
}

export default { newClientRequestId };
